<template>
  <div class="business-categories page">
    <div class="page-title">Business Categories</div>
    <div class="page-content">
      <loading-panel :loading="loading" class="">
        <!-- NEW CATEGORY PANEL -->
        <div class="new-category row mx-0">
          <div class="input-group py-2">
            <input
              class="form-control"
              v-model.trim="newCategory"
              placeholder="Type new Business Category here"
            />
            <div class="input-group-append">
              <button
                class="btn small-btn btn-success"
                type="button"
                @click="create()"
              >
                <i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <hr />

        <div class="text-danger" v-if="error">{{ error }}</div>
        <div v-if="categories.length > 0" class="my-2 input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" id="filter">
              <i class="fa fa-search"></i>
            </span>
          </div>
          <input
            v-model.trim="filter"
            @keyup="applyFilter()"
            class="form-control"
            aria-describedby="filter"
            placeholder="filter by name"
          />
        </div>
        <div v-else>No categories found.</div>
        <div v-for="(category, ind) in filteredCategories" :key="`${ind}_loc`">
          <div class="input-group py-2">
            <input
              class="form-control"
              :value="category.name"
              aria-describedby="delete"
              disabled
            />
            <div class="input-group-append">
              <button
                class="btn small-btn btn-danger"
                type="button"
                @click="deleteCategory(category.name)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </loading-panel>
    </div>
  </div>
</template>

<script>
import SinglePane from "@/layouts/SinglePane";

export default {
  name: "categories",
  components: {
    // SinglePane,
  },
  data: () => ({
    loading: true,
    error: "",
    filteredCategories: [],
    categories: [],
    selected: null,
    filter: "",
    newCategory: "",
  }),
  methods: {
    applyFilter() {
      this.filteredCategories = this.categories.filter((category) =>
        category.name.toLowerCase().includes(this.filter.toLowerCase())
      );
    },
    async create() {
      try {
        if (!this.newCategory) {
          this.error = "New category name is required.";
          return;
        }

        this.loading = true;
        const response = await this.$web.addBusinessCategory(this.newCategory);
        if (response.data.categories && response.data.categories.length > 0) {
          this.categories = response.data.categories;
          this.newCategory = "";
          this.applyFilter();
        }
      } catch (err) {
        console.log(err);
        this.error = "An error occurred.";
      } finally {
        this.loading = false;
      }
    },
    async deleteCategory(category) {
      try {
        if (!category) {
          this.error = "Cannot delete this category.";
          return;
        }

        this.loading = true;
        const response = await this.$web.deleteBusinessCategory(category);
        if (response.data.categories) {
          this.categories = response.data.categories;
          this.applyFilter();
        }
      } catch (err) {
        console.log(err);
        this.error = "An error occurred.";
      } finally {
        this.loading = false;
      }
    },
    async load() {
      try {
        this.loading = true;
        const response = await this.$web.getBusinessCategories();
        if (response.data.categories && response.data.categories.length > 0) {
          this.categories = response.data.categories;
          this.applyFilter();
        }
      } catch (err) {
        console.log(err);
        this.error = "An error occurred.";
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    this.load();
  },
};
</script>

<style scoped>
.form-control:disabled {
  background-color: white;
}
</style>
